var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.96967 3.96979C10.2626 3.6769 10.7373 3.6769 11.0302 3.96979C11.3231 4.26269 11.3231 4.73746 11.0302 5.03034L4.81049 11.2501H20.9999C21.4141 11.2501 21.7499 11.5859 21.7499 12.0001C21.7499 12.4142 21.4141 12.75 20.9999 12.7501H4.81049L11.0302 18.9698L11.082 19.0264C11.3222 19.321 11.3048 19.7558 11.0302 20.0303C10.7556 20.3049 10.3209 20.3224 10.0263 20.0821L9.96967 20.0303L2.46967 12.5303C2.17678 12.2374 2.17678 11.7627 2.46967 11.4698L9.96967 3.96979Z",
    fill: "#0F172A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.77b15ac0f73e711fd49bc70eda574c07.svg";
export { ForwardRef as ReactComponent };